import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../setup";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Profile"],
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (body) => {
        return { url: `auth/login`, method: "POST", body };
      },
    }),
    logout: builder.mutation({
      query: () => {
        const token = localStorage.getItem("access_token");
        return {
          url: `auth/logout`,
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
    }),
    refreshToken: builder.query({
      query: () => {
        const token = localStorage.getItem("refresh_token");
        return {
          url: `auth/refresh`,
          method: "GET",
          params: { refresh_token: token },
        };
      },
    }),
    getCustomerMe: builder.query({
      query: () => ({
        url: `auth/customer/me`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useLazyGetCustomerMeQuery,
} = authApi;
